import * as React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, Typography } from 'components/ui';
import { LogUserErrorSeverity, useLogUserErrorMessage } from 'hooks/log-user-error-message';
import { t } from 'state/intl/translations';
import { getDesignToken } from 'styles/constants';

import { getQuestCheckConnectionText, getQuestLoadErrorText } from '../custom-text';

import { ImageWrapper, ReloadButton } from './styled';

export const QuestCardError = ({ refetch }: { refetch: () => void }) => {
  const errorHeaderMessage = getQuestLoadErrorText();

  useLogUserErrorMessage({
    message: errorHeaderMessage,
    severity: LogUserErrorSeverity.GeneralError,
    context: {
      moreInfo: 'quest-card-error.tsx',
    },
  });

  return (
    <Box style={styles.container}>
      <ImageWrapper>
        <Icon variant="errorFill" size="12" color={getDesignToken('icon-disabled')} />
      </ImageWrapper>
      <Box style={styles.content}>
        <Typography variant="headerTwo">{errorHeaderMessage}</Typography>
        <Typography mb="$4">{getQuestCheckConnectionText()}</Typography>
        <Box style={styles.button}>
          <ReloadButton
            leftIcon={
              <Icon variant="refresh" size="sm" color={getDesignToken('border-color-error')} />
            }
            onPress={refetch}
          >
            {t('tryAgain')}
          </ReloadButton>
        </Box>
      </Box>
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: getDesignToken('background-pattern'),
    borderRadius: 12,
    margin: 16,
    overflow: 'hidden',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 3,
  },
  content: { padding: 16 },
  button: { flexShrink: 1 },
});
